import { render, staticRenderFns } from "./DimmingDialog.vue?vue&type=template&id=0115f54d&scoped=true"
import script from "./DimmingDialog.vue?vue&type=script&lang=ts"
export * from "./DimmingDialog.vue?vue&type=script&lang=ts"
import style0 from "./DimmingDialog.vue?vue&type=style&index=0&id=0115f54d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0115f54d",
  null
  
)

export default component.exports